// =require "vendor/jquery/jquery-1.11.1.min.js"
// =require "vendor/underscore/underscore.js"
// =require "vendor/modernizr/modernizr.js"
// =require "vendor/moment/moment.js"
// =require "vendor/moment/moment.nl.js"
// =require "vendor/ember/handlebars-v1.3.0.js"
// =require "vendor/ember/ember-1.8.1.js"
// =require "vendor/ember/ember-data.js"
// =require "vendor/dropzone/dropzone.js"
// =require "vendor/bootstrap/bootstrap.js"
// =require "vendor/customselect/jquery.customSelect.min.js"
// =require "vendor/tablesorter/jquery.tablesorter.js"
// =require "vendor/bootstrap-datepicker/bootstrap-datepicker.min.js"
// =require "vendor/ember-validations/ember-validations.js"
// =require "vendor/jrange/jquery.range-min.js"
// =require "vendor/sweetalert/sweetalert.min.js"
// =require "vendor/js-cookie/js.cookie.js"
// =require "vendor/clndr/clndr.js"
// =require "vendor/slick/slick.min.js"
